import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { cnpjMask, cpfMask } from '../../shared/mask';

function ReportCNPJs({ dados }) {

    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [docreport, setDocreport] = useState('');
    const { state } = useLocation();

    useEffect(() => {
        let doc = state[0].doc_number.length === 14 ? cnpjMask(state[0].doc_number) : cpfMask(state[0].doc_number)
        setDocreport(doc);
    }, []);

    const handleClickInfo = (data, title, index) => {
        setActiveData(data);
        setTitleModal(title);
        setShowModal(true);
    }

    return (
        <>
            <Row className='scrollbar d-flex' style={{ height: 'calc(100vh - 480px)' }}>
            {dados['Participação em Empresas'] && dados['Participação em Empresas']?.length > 0 ? dados['Participação em Empresas'].map((item, index) => 
                
                    <Col key={item + index} md={4}>
                        <div className='rect-content-risks' style={{ height: '116px' }}>
                            <p className='two-rows' title={item['Razão Social']}><b>Razão Social: </b> {item['Razão Social']}</p>
                            {item['CNPJ da Matriz'] && <p><b>CNPJ: </b> {cnpjMask(item['CNPJ da Matriz'])}</p>}
                            <div className='rect-link cursor-pointer' style={{ top: '65px' }} onClick={() => handleClickInfo(item, 'Participação em Empresas')}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    </Col>
                    
                ):<Row><span className="fs-6">Não foi identificada "Participação na Empresa"</span></Row>}
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes - Participação em Empresas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData && (
                        <>
                            <p className='rect-tx-1 fs-5' title={titleModal}>{titleModal}</p>
                            {activeData && Object.keys(activeData).length > 0 && Object.keys(activeData).map((key, i) => (
                                <div key={activeData + i}>
                                    {
                                        key === 'Razão Social' || key === 'CNPJ da Matriz' ? <div className='mb-2 color-tertiary'><b>{key}</b>: {activeData[key]}</div> :
                                        <div><b>{key}</b>: {activeData[key]}</div>
                                    }
                                </div>
                            ))}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportCNPJs;